import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Preference, RelativeTimePipe } from '@marmon/frontend/common';
import {
	TuiButton,
	TuiHint,
	TuiIcon,
	TuiLoader,
	TuiTitle,
} from '@taiga-ui/core';
import { TuiPulse } from '@taiga-ui/kit';
import { map, timer } from 'rxjs';
import { ExportApiService, ExportStateService } from '../../services';

@Component({
	selector: 'mar-export-manager',
	templateUrl: 'export-manager.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TuiLoader,
		TuiButton,
		AsyncPipe,
		TranslocoPipe,
		TuiIcon,
		RelativeTimePipe,
		TuiPulse,
		TuiHint,
		TuiTitle,
	],
	host: { class: 'block' },
	providers: [RelativeTimePipe],
})
export class ExportManagerComponent {
	readonly exportStateService = inject(ExportStateService);
	readonly exportApiService = inject(ExportApiService);

	readonly generating$ = this.exportStateService.generating$;
	readonly relativeTime = inject(RelativeTimePipe);

	readonly tutorialComplete = new Preference('tutorial.exports.location');

	readonly loadingTime$ = timer(0, 1000).pipe(
		map(() => this.generating$.value?.startedAt),
		map((value) => {
			if (!value) return null;
			return this.relativeTime.transform(value, {
				showNow: false,
				exact: true,
				ago: false,
			});
		}),
	);

	onDownload() {
		this.exportStateService.downloadExport();
	}

	onClear() {
		this.exportStateService.clearExport();
	}

	onRetry() {
		const value = this.generating$.value;
		if (!value) throw Error('There is no export to retry');
		this.exportApiService.generate(value.payload);
	}

	onCompleteTutorial() {
		this.tutorialComplete.set(true);
	}
}
